import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  const linkClass = (path: string) => {
    const active = location.pathname === path || (path !== '/' && location.pathname.startsWith(path));
    return active
      ? 'text-accent-600 font-medium'
      : 'text-foreground-700 hover:text-accent-600 transition-colors duration-200';
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-8 h-8 bg-accent-500 rounded-lg flex items-center justify-center">
              <i className="ri-quill-pen-line text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-semibold text-foreground-950 whitespace-nowrap">
              17.c-起草口
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`${linkClass('/')} text-sm whitespace-nowrap`}>首页</Link>
            <Link to="/category" className={`${linkClass('/category')} text-sm whitespace-nowrap`}>分类浏览</Link>
            <Link to="/about" className={`${linkClass('/about')} text-sm whitespace-nowrap`}>关于我们</Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category"
              className="px-4 py-2 bg-accent-500 text-background-50 rounded-md text-sm font-medium hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap"
            >
              开始起草
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className={`${linkClass('/')} text-sm py-2`}>首页</Link>
            <Link to="/category" className={`${linkClass('/category')} text-sm py-2`}>分类浏览</Link>
            <Link to="/about" className={`${linkClass('/about')} text-sm py-2`}>关于我们</Link>
            <Link
              to="/category"
              className="px-4 py-2 bg-accent-500 text-background-50 rounded-md text-sm font-medium text-center whitespace-nowrap"
            >
              开始起草
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}